/**
 * Style/variant slugs for widget-15..31, one source of truth shared by every
 * preview component here. Must stay identical to the STYLES map in
 * public/assets/bootstrap/widget-v2.js (the real embed script) — there is no
 * shared module between the two (one ships as a plain script, the other
 * builds through webpack), so any change to either must be mirrored by hand
 * in the other.
 */
export const WIDGET_V2_STYLES: Record<string, string[]> = {
  badge: ["standard", "compact", "vertical", "mono", "logo-combo"],
  strip: ["standard", "with-cta", "text-only"],
  stars: ["stars-only", "with-count", "with-score"],
  ring: ["ring", "with-breakdown", "dark-tile"],
  banner: ["wide", "slim"],
  licence: ["regulator-chips", "verified-card"],
  nudge: ["toast", "inline-ticker"],
  collect: ["primary", "outline", "floating"],
  comparison: ["bars", "rank-card"],
  signature: ["full-block", "one-line"],
  qr: ["poster", "table-tent", "sticker"],
  tab: ["right-edge", "left-edge", "expanded-panel"],
  bar: ["top-bar", "bottom-bar"],
  counter: ["reviews-count", "combined-stats"],
  carousel: ["cards", "spotlight", "two-column"],
  wall: ["masonry", "compact-list"],
  list: ["summary-list", "list-only", "with-filters"],
};

/** Picks a valid style for `widget`, falling back to its first/standard style when `requested` is missing or unknown. */
export function resolveWidgetV2Style(widget: string, requested?: string): string {
  const list = WIDGET_V2_STYLES[widget] ?? [];
  if (requested && list.includes(requested)) return requested;
  return list[0] ?? "";
}
